import PropTypes from "prop-types";
import { CloseIcon, SearchIcon } from "./Icons.jsx";
import s from "./SearchInput.module.css";

export default function SearchInput({
  value,
  onChange,
  onClear,
  placeholder,
  ariaLabel,
  className,
  inputRef,
  disabled,
}) {
  return (
    <div className={`${s.searchInput}${className ? ` ${className}` : ""}`}>
      <SearchIcon />
      <input
        ref={inputRef}
        type="text"
        placeholder={placeholder}
        aria-label={ariaLabel}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
      {value && onClear && (
        <button
          className={s.clearBtn}
          onClick={onClear}
          aria-label="Clear search"
        >
          <CloseIcon />
        </button>
      )}
    </div>
  );
}

SearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func,
  placeholder: PropTypes.string,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  inputRef: PropTypes.object,
  disabled: PropTypes.bool,
};
